// @ts-nocheck
import CustomerChangeModal from '@/components/modals/customer-change-modal';
import * as Enums from '@/utils/enums';

const QuoteCustomerChange = ({ open, onClose, quote, accessStatus, onCustomerChanged }: any) => (
    <CustomerChangeModal
        open={open}
        onClose={onClose}
        itemLabel={quote.QuoteNumber}
        moduleLabel="quote"
        description="Changing the customer reassigns the contact and location on this quote. You cannot change the customer on a quote that is not in draft."
        checkUrl={`/Quote/QuoteCustomerChangeCheck?quoteID=${quote.ID}`}
        changeUrl="/Quote/QuoteCustomerChange"
        itemIdKey="QuoteID"
        itemId={quote.ID}
        moduleType={Enums.Module.Quote}
        excludedCustomerID={quote.CustomerID}
        accessStatus={accessStatus}
        onCustomerChanged={onCustomerChanged}
    />
);

export default QuoteCustomerChange;
